module.exports = __webpack_public_path__ + "static/media/ios-chatboxes.e286abea.svg";